export default __webpack_public_path__ + "static/media/MainUnit-Red-24x24.4ccd69fb.svg";